// BGM設定
export class SoundPlayer {

    instanceSE:createjs.AbstractSoundInstance;
    instanceBGM:createjs.AbstractSoundInstance;
    timerStart:Date;
    timercount:number;
    thisticker:any;    
    par:number;
    bgm:string;
    sec:number= 1300;
    waiting:number = 500;
    vol:number = 0.75;
    //vol:number = 0.2;

    init() {
        createjs.Sound.volume = this.vol;
        //createjs.Sound.volume = 0;
        //this.instance = createjs.Sound.createInstance("BGM_002");
        //this.instance.volume = 0;
    }

    playSE(sefile) {
        this.instanceSE = createjs.Sound.play(sefile , { interrupt: createjs.Sound.INTERRUPT_NONE, loop: 0, volume:this.vol });
    }

    playBGM(bgmfile) {
        this.bgm = bgmfile;
        createjs.Sound.stop();
        this.instanceBGM = createjs.Sound.play(this.bgm , { interrupt: createjs.Sound.INTERRUPT_NONE, loop: -1, volume:this.vol });
    }

    stop() {
        
        createjs.Sound.stop();
        createjs.Sound.volume = this.vol;
        if (this.thisticker) {
            createjs.Ticker.removeEventListener('tick', this.thisticker);
        }
    }

    stopSE(sefile) {
        this.instanceSE.stop();
    }

    stopBGM() {
        this.instanceBGM.stop();
    }

    stopping() {

        // いったん止める
        createjs.Ticker.removeEventListener('tick', this.thisticker);

        setTimeout(() => {
            this.timerStart = new Date();
            this.thisticker = createjs.Ticker.addEventListener('tick', () => {

                var cnt = new Date().getTime() - this.timerStart.getTime();
                this.timercount += cnt;

                var par = 1-(cnt/this.sec);
                if (par <= 0) par = 0;
                if (par >= 1) par = 1;
                //console.log(par);
                createjs.Sound.volume = par;
                
                if (par <= 0) {
                    this.stop();
                }
            });
        }, this.waiting);
    }
}